import { API } from '@/shared/plugins/Api/API'
import ProjectQuotas from './ProjectQuotas'
import OrganizationQuotas from './OrganizationQuotas'

class QUOTA extends API {
  constructor (id) {
    super(id, true, true)
    this.projects = new ProjectQuotas(id)
    this.organizations = new OrganizationQuotas(id)
  }

  async maxQuotas () {
    return await this.request({
      method: 'GET',
      url: 'v1/max'
    })
  }
}

export default QUOTA
